import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListView } from '@/shared/components/custom/list-view/components/ListView';
import { getMergedListColumns, type MergedListItem } from '../../adapters/formColumns';

interface FormsListTableProps {
  items: MergedListItem[];
}

export function FormsListTable({ items }: FormsListTableProps) {
  const { t } = useTranslation('forms');
  const { orgId } = useParams<{ orgId: string }>();

  const columns = getMergedListColumns({ t, orgId: orgId ?? '' });

  return (
    <ListView
      data={items}
      columns={columns}
      getRowId={(entry) => `${entry.itemType}-${entry.item.id}`}
      data-testid="forms-list-table"
    />
  );
}
